import ListFormHoc from "../../../../../utils/listFormHoc";
import BackToSettings from "../BackToSettings";
import List from "./list";
import Form from "./form";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setMainHeading } from "../../../../../redux/modules/mainHeading/slice";

const LabDepartments = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setMainHeading("Lab Departments"));
  }, [dispatch]);

  return (
    <>
      <BackToSettings />
      <ListFormHoc List={List} Form={Form} module="labSettings" />
    </>
  );
};

export default LabDepartments;
